import type { SpaceKey } from '@/api/types'

export type SpaceFeature = 'kb' | 'tickets' | 'chat' | 'jira' | 'ops'

export type SpaceConfig = {
  icon: string
  features: SpaceFeature[]
  // route name the space lands on when the current feature isn't part of it
  home: string
  // not released yet: only offered in the local and dev environments
  devOnly?: boolean
}

export const DEFAULT_SPACE: SpaceKey = 'general'

export const SPACE_CONFIG: Record<SpaceKey, SpaceConfig> = {
  general: {
    icon: 'fas fa-globe',
    features: ['kb', 'tickets', 'chat', 'jira'],
    home: '/[[space]]/kb/',
  },
  development: {
    icon: 'fas fa-code',
    features: ['kb', 'chat'],
    home: '/[[space]]/kb/',
  },
  operations: {
    icon: 'fas fa-server',
    features: ['ops', 'chat'],
    home: '/ops/',
  },
}

export function isKnownSpace(key: unknown): key is SpaceKey {
  return typeof key === 'string' && Object.hasOwn(SPACE_CONFIG, key)
}
